<template>
    <div class="passReset pswdReset">
        <div class="pWLeft">
            <el-form :model="passSetForm" ref="passSetForm" :rules="rules">
                <el-form-item
                    label="账号："
                    >
                    <span style="margin-left:20px;">
                        {{$store.state.currentUser != null ? ($store.state.currentUser.uid ? $store.state.currentUser.uid : null) : null}}
                    </span>
                </el-form-item>
                <el-form-item
                    label="旧密码："
                    prop="oldPassWord"
                    >
                    <el-input type="password" size="medium" @blur="oldPswdBlur" placeholder="请输入旧密码" v-model.trim="passSetForm.oldPassWord" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item
                    label="新密码："
                    prop="newPassWord"
                    >
                    <el-input type="password" @keyup.native="cipher" size="medium" placeholder="请输入新密码" v-model.trim="passSetForm.newPassWord" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item
                    label="重复新密码："
                    prop="repeatPassWord"
                    >
                    <el-input type="password" size="medium" placeholder="请重复输入新密码" v-model.trim="passSetForm.repeatPassWord" auto-complete="off"></el-input>
                </el-form-item>
                <p style="margin-top:20px;" v-show="passSetForm.newPassWord != '' || passSetForm.repeatPassWord != ''">安全等级</p>
                <div class="stateCantent" v-show="passSetForm.newPassWord != '' || passSetForm.repeatPassWord != ''">
                    <span class="passState">{{passState.state || '低'}}</span>
                    <div class="stateBar">
                        <transition name="fade">
                            <div :class="{
                                stateLow: passState.status == 'low',
                                stateMiddle: passState.status == 'middle',
                                stateStrong : passState.status == 'strong'}">
                            </div>
                        </transition>
                    </div>
                </div>
                <el-form-item style="margin-top:20px;">
                    <el-button type="primary" size="small" @click="submitForm('passSetForm')">确定</el-button>
                    <el-button type="text" @click="resetForm('passSetForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="pWRight">
            <p>1. 长度8-16位字符</p>
            <p>2. 不能包含空格</p>
            <p>3. 必须包含数字、小写字母、大写字母、特殊字符（!&lt;&gt;%&amp;_+¥除外）</p>
            <p>4. 不能包含账号</p>
            <p>5. 不能使用前5次历史密码</p>
        </div>
    </div>
</template>

<script>
import cipher from '../utils/strengthCipher'
import http from '../utils/httpClient'
export default {
    name: 'updatePassword',
    data () {
        var validateOldPswd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入旧密码'));
            } else {
                callback();
            }
        };
        var validatePass = ( rule, value, callback ) => {
            if ( value === '' )
                callback( new Error('请输入密码') );
            else if( value.length < 8 || value.length > 16 ) {
                callback( new Error('长度需在 8 到 16 个字符') );
            } else if (value.match(/\s/g)) {
                callback( new Error('不能包含空格') );
            } else if (value == this.passSetForm.oldPassWord) {
                callback( new Error('不能与原密码相同') );
            } else if (this.$store.state.currentUser.uid && value.indexOf(this.$store.state.currentUser.uid) != -1) {
                callback( new Error('不能包含账号') );
            } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~@#$^*()\-=\[{}\]\\|:;"',.?/g])[\w`~@#$^*()\-=\[{}\]\\|:;"',.?/]{8,16}/.test(value)) {
                callback( new Error('必须包含字母、数字、特殊字符') );
            } else {
                if ( this.passSetForm.repeatPassWord !== '' )
                    this.$refs.passSetForm.validateField( 'repeatPassWord' );
                callback();
            }
        };
        var validatePass2 = ( rule, value, callback ) => {
            if ( value === '' )
                callback( new Error( '请再次输入密码' ) );
            else if (value !== this.passSetForm.newPassWord)
                callback( new Error( '两次输入密码不一致!' ) );
            else
                callback();
        };
        return {
            passSetForm: {
                uid: this.$store.state.currentUser != null ? (this.$store.state.currentUser.uid ? this.$store.state.currentUser.uid : null) : null,
                oldPassWord: '',
                newPassWord: '',
                repeatPassWord: ''
            },
            rules: {
                oldPassWord: [
                    { required: true, validator: validateOldPswd, trigger: 'blur' }
                ],
                newPassWord: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ],
                repeatPassWord: [
                    { required: true, validator: validatePass2, trigger: 'blur' }
                ]
            },
            passState: {
                status: ''
            },
        }
    },
    methods : {
        cipher(){
            this.passState = cipher.validate( this.passSetForm.newPassWord );
        },
        oldPswdBlur () {

        },
        // 确认按钮点击事件
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.passSetForm);
                    var params = {
                        newPassword: this.passSetForm.newPassWord,
                        newPasswordVal: this.passSetForm.repeatPassWord,
                        oldPassword: this.passSetForm.oldPassWord
                    }
                    //请求修改密码的接口
                    http.post('/people/password/update',params)
                    .then(res => {
                        if (res.head.responseCode == '0') {
                            this.$message.success(res.head.responseMessage);
                            this.$store.commit('changeResetSuccess',!this.$store.state.resetSuccess);
                            this.$router.go(-1);
                        } else {
                            this.$message.error(res.head.responseMessage);
                        }
                    })
                    .catch( err => {
                        this.$message.error(err);
                    })
                } else {
                    // this.$message.error('验证未通过!');
                    return false;
                }
            });
        },
        // 取消按钮点击事件
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
.passReset{
    display: flex; align-items: center; justify-content: center; height: 100%; font-size: 12px;
    .pWLeft{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        min-width: 25%; /* 300px */
        .el-form{
            height: inherit; width: 100%; margin-top: 10px;
            .stateCantent{
                width: 100%;height: 36px;line-height: 36px;display: flex;align-items:center; margin-bottom: 10px;margin-top: 10px;
                .passState{
                    display: inline-block;min-width: 30px;
                }
                .stateBar{
                    flex: 1; overflow: hidden; float:left;border-radius: 60px;overflow: hidden; background: #f2f2f2;
                    div{
                        height: 8px;
                    }
                    .fade-enter-active, .fade-leave-active{
                        transition: all .3s ease-in;
                    }
                    .fade-enter, .fade-leave-active{
                        opacity: 0;
                    }
                    .stateLow{
                        width: 33%;background: #FE5624;transition: all .7s ease-in;
                    }
                    .stateMiddle{
                        width: 66%;background: #3BA2E9;transition: all .7s ease-in;
                    }
                    .stateStrong{
                        width: 100%;background: #80CD6E;transition: all .7s ease-in;
                    }
                }
            }
        }
    }
    .pWRight{
        float: right; margin-left: 30px;padding-top: 50px;
        p{
            font-size: 12px;padding-bottom: 16px; color: #999999;
        }
    }
}
.pswdReset {
    height: 100%;overflow-x: hidden;padding: 10px 0 20px 0;
    .el-button--primary {
        width: 100%;
        margin: 0;
    }
    .el-button--text {
        color: #333;
        position: absolute;
        right: -50px;
        top:0;
    }
}
</style>
<style lang="scss">
.el-form-item__label{
    float: none; font-size: 12px; font-weight: 600; color: #2A2A2A;
}
.el-form-item{
    margin-bottom: 4px;
}
.el-input--medium .el-input__inner{
    font-size: 12px!important;
}

</style>




// WEBPACK FOOTER //
// src/components/updatePassword.vue